import { Notification as LibNotification } from '@capacitor-firebase/messaging';

export enum ClickActions {
  VideoCalling = 'Start_VideoCalling',
  StartChat = 'ChatMessage',
  Appointments = 'Appointments',
  Careplans = 'Careplans',
  Medications = 'Medications',
  PrivacyPolicyUpdate = 'privacyPolicyUpdate',
  PdfReport = 'pdfReport',
  CaretaskAnswerError = 'caretaskAnswerError',
}

export type CustomNotification = {
  click_action: ClickActions;
  firebasePatientId: string;
  jitsiUrl?: string;
  siteUUID?: string;
  institution: {
    id: number;
    uuid: string;
    name: string;
  };
};

export type NotificationData = {
  custom_notification: string;
};

export type Notification = LibNotification & { data: NotificationData };
